import { render } from "./LandingRepriseDepot.vue?vue&type=template&id=005325a0&scoped=true"
import script from "./LandingRepriseDepot.vue?vue&type=script&lang=js"
export * from "./LandingRepriseDepot.vue?vue&type=script&lang=js"

import "./LandingRepriseDepot.vue?vue&type=style&index=0&id=005325a0&lang=scss&scoped=true"

import exportComponent from "/srv/ewigo-local-code/minisite/releases/20261028142257-afc99f34de38fbb8c9a48d510159883af3f0ac39/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005325a0"]])

export default __exports__